
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const SiteSettingsForm: React.FC = () => (
  <form className="space-y-6">
    <div className="space-y-2">
      <label className="text-sm font-medium" htmlFor="siteName">
        Site Name
      </label>
      <Input id="siteName" defaultValue="AI Nexus" />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-medium" htmlFor="siteDescription">
        Site Description
      </label>
      <Input id="siteDescription" defaultValue="The premier destination for AI insights and knowledge" />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-medium" htmlFor="contactEmail">
        Contact Email
      </label>
      <Input id="contactEmail" defaultValue="support@ainexus.com" />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-medium" htmlFor="articlesPerPage">
        Articles Per Page
      </label>
      <Input id="articlesPerPage" type="number" defaultValue="12" />
    </div>

    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        id="enableComments"
        className="h-4 w-4 rounded border-gray-300 text-ai-indigo focus:ring-ai-indigo"
        defaultChecked={true}
      />
      <label className="text-sm font-medium" htmlFor="enableComments">
        Enable article comments
      </label>
    </div>

    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        id="autoPublish"
        className="h-4 w-4 rounded border-gray-300 text-ai-indigo focus:ring-ai-indigo"
        defaultChecked={false}
      />
      <label className="text-sm font-medium" htmlFor="autoPublish">
        Auto-publish admin articles
      </label>
    </div>
    <Button className="bg-ai-indigo hover:bg-ai-indigo/90">Save Settings</Button>
  </form>
);

export default SiteSettingsForm;
